var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsvFileWithContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "70px",
    height: "100px",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        opacity: .6;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #6c7d8a;\n      }\n\n      .st3 {\n        fill: #485d6e;\n      }\n\n      .st4 {\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "70 100 0 100 0 0 50 0 50 20 70 20 70 100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "70 20 50 20 50 0 70 20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 3.9,
    y: 55.2,
    width: 29.2,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 36.9,
    y: 55.2,
    width: 29.2,
    height: 4.2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 3.9,
    y: 63.5,
    width: 29.2,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 36.9,
    y: 63.5,
    width: 29.2,
    height: 4.2
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 3.9,
    y: 71.8,
    width: 29.2,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 36.9,
    y: 71.8,
    width: 29.2,
    height: 4.2
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 3.9,
    y: 80.2,
    width: 29.2,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 36.9,
    y: 80.2,
    width: 29.2,
    height: 4.2
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 3.9,
    y: 88.5,
    width: 29.2,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 36.9,
    y: 88.5,
    width: 29.2,
    height: 4.2
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,39c0-4.2,2.9-7.1,7.2-7.1s3.2.5,4.3,1.4v2.6c-1.2-1.1-2.7-1.7-4.2-1.7-2.8,0-4.7,2-4.7,4.8s2.2,4.9,4.8,4.9,3-.6,4.2-1.7v2.6c-1.1.9-2.6,1.4-4.3,1.4-4.3,0-7.2-2.9-7.2-7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.1,42.1c1.2,1.1,2.8,1.7,4.4,1.7s2.7-.7,2.7-1.9-.9-1.8-2.7-1.9c-2.7-.2-4.4-1.7-4.4-4s2-4.2,4.9-4.2,2.9.5,4,1.3v2.5c-1-1-2.4-1.6-3.8-1.6s-2.6.7-2.6,1.9.8,1.7,2.8,1.9c2.8.3,4.4,1.6,4.4,4s-2,4.2-5.1,4.2-3.3-.5-4.5-1.4v-2.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.8,32.1l3.9,11.3h0l3.7-11.3h2.7l-4.9,13.8h-3l-5-13.8h2.7-.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvFileWithContent);
export default __webpack_public_path__ + "static/media/csv-file-with-content.7df8676ce6810bedec59d4bb4c9e8504.svg";
export { ForwardRef as ReactComponent };